import { stringify } from 'qs';
const INDICES = {
    arrayFormat: 'indices',
    skipNulls: true,
    encode: false,
};
export const serializeParams = (params) => stringify(params, INDICES);
//# sourceMappingURL=serializeParams.js.map